<template>
  <div>
    <loading :active.sync="isLoading"
             :is-full-page="fullPage"
             color="green"
             loader="dots"
    ></loading>
    <div class="row">
      <div class="col-md-12 col-12">
        <h3 class="title m-t-10 m-l-15">{{ libraries.currentLibrary ? libraries.currentLibrary.title : '' }}</h3>
        <ol class="breadcrumb" style="margin-top: -20px">
          <li class="breadcrumb-item"><a href="/"><i class="mdi mdi-home"></i> На головну</a></li>
          <li class="breadcrumb-item"><a href="/library/transfers-to"><i class="mdi mdi-folder-multiple-outline"></i>
            Передачі книжок</a></li>
          <li class="breadcrumb-item active">Редагування інформації</li>
        </ol>
      </div>
    </div>
    <div class="card">
      <div class="card-body">
        <div class="row m-3">
          <h4 class="title" v-if="$route.name === 'TransferCreate'">Нова Передача</h4>
          <h4 class="title" v-else>Форма редагування</h4>
        </div>
        <div class="m-3 floating-labels reader-form">
          <div class="row">
            <div class="col-lg-6">
              <div class="form-group">
                <label for="library_to">ПЕРЕДАТИ В БІБЛІОТЕКУ</label>
                <select v-model="transfer.library_to" id="library_to" class="form-control">
                  <option v-for="library in libraries.connectedLibraries" :value="library.id" v-html="library.title"></option>
                </select>
                <span class="bar"></span>
                <div class="invalid-feedback" v-if="errors.hasOwnProperty('library_to')">
                  <span v-for="item in errors.library_to">{{ item }}</span>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="form-group">
                <label for="doc_number" class="floatings">НОМЕР ДОКУМЕНТА</label>
                <input type="text" class="form-control" id="doc_number" v-model="transfer.doc_number" ref="doc_number" :class="errors.hasOwnProperty('doc_number') ? 'is-invalid' : ''" @input="delete errors.doc_number" />
                <span class="bar"></span>
                <div class="invalid-feedback" v-if="errors.hasOwnProperty('doc_number')">
                  <span v-for="item in errors.doc_number">{{ item }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-6">
              <div class="form-group upload_file">
                <label class="upload_file__lable" :class="errors.hasOwnProperty('file') ? 'is-invalid' : ''">
                  <span class="upload_file__title">СУПРОВІДНИЙ ДОКУМЕНТ</span>
                  <input type="file" class="form-control-file" name="file" ref="file" @change="changeFile">
                  <span class="upload_file__filename" v-if="uploadedFile">{{ uploadedFile.name }}</span>
                </label>
                <div class="invalid-feedback" v-if="errors.hasOwnProperty('file')">
                  <span v-for="item in errors.file">{{ item }}</span>
                </div>
                <span v-if="transfer.file">Поточний файл: <a :href=transfer.file download>{{ transfer.file.replace(/.+\//, '') }}</a></span>
                <span class="bar"></span>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="form-group">
                <label for="sent_date" class="floatings">ДАТА ДОКУМЕНТА</label>
                <datepicker :language="uk" :input-class="'form-control'" :monday-first="true" :format="'yyyy-MM-dd'" id="sent_date" v-model="transfer.sent_date" :class="errors.hasOwnProperty('sent_date') ? 'is-invalid' : ''" @input="delete errors.sent_date"></datepicker>
                <span class="bar"></span>
                <div class="invalid-feedback" v-if="errors.hasOwnProperty('sent_date')">
                  <span v-for="item in errors.sent_date">{{ item }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12">
              <div class="form-group">
                <label for="comment" class="floatings">КОММЕНТАР</label>
                <textarea id="comment" v-model="transfer.comment" ref="comment" rows="5" :class="errors.hasOwnProperty('comment') ? 'is-invalid' : ''" @input="delete errors.comment"></textarea>
                <span class="bar"></span>
                <div class="invalid-feedback" v-if="errors.hasOwnProperty('comment')">
                  <span v-for="item in errors.comment">{{ item }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="form-group float-sm-right m-b-40 m-r-15" id="save-cancel">
          <div  class="btn btn-outline-secondary btn-lg mt-auto mb-auto" style="padding: 14px">
            <a :href="transfer.id ? '/library/transfers/' + transfer.id : '/library/transfers-to'"
               style="font-size: 15px;">
              <i class="mdi mdi-close-circle"></i> Скасувати
            </a>
          </div>
          <button @click="saveTransfer" class="btn btn-success btn-lg m-l-20" type="submit" style="font-size: 15px"><i
              class="mdi mdi-check-circle"></i> Зберегти
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import Datepicker from 'vuejs-datepicker';
import {uk} from 'vuejs-datepicker/dist/locale';
export default {
  name: "TransferCreateEdit",
  components: {Loading, Datepicker},
  data() {
    return {
      libraries: {
        currentLibrary: {},
        connectedLibraries: [],
      },
      uk: uk,
      isLoading: false,
      fullPage: true,
      uploadedFile: {},
      allowedMimeTypes: {
        doc: 'application/msword',
        xls: 'application/vnd.ms-excel',
        pdf: 'application/pdf',
      },
      transfer: {
        id: '',
        library_from: '',
        library_to: '',
        doc_number: '',
        comment: '',
        file: '',
        status: '',
        sent_date: '',
      },
      errors: {},
    }
  },
  mounted() {
    this.getLibraries()
    if (this.$route.name == 'TransferEdit') {
      this.getTransfer(this.$route.params.id);
    }
  },
  methods: {
    changeFile(e) {
      delete this.errors.file;
      this.uploadedFile = e.target.files[0];
    },

    isFiletypeAllowed(file) {
      return Object.values(this.allowedMimeTypes).indexOf(file.type) > -1;
    },

    saveTransfer() {
      this.isLoading = true;
      let form = new FormData();
      let url, method;
      if (this.$route.name === 'TransferCreate') {
        url = '/library/transfers';
        method = 'post';
      } else if (this.$route.name === 'TransferEdit') {
        method = 'put';
        url = '/library/transfers/' + this.transfer.id;
      }
      form.append('_method', method);

      for (let item in this.transfer) {
        let ignore = ['id', 'library_from', 'status', 'user_id', 'created_at', 'updated_at'];
        if (ignore.includes(item)) {
          continue;
        } else if ('file' === item) {
          if (this.uploadedFile && this.uploadedFile.name) {
            form.append(item, this.uploadedFile);
          }
        } else if ('sent_date' === item) {
          let date = new Date(this.transfer[item]);
          let month = date.getMonth() + 1;
          month = month < 10 ? '0' + month : month;
          let day = date.getDate();
          day = day < 10 ? '0' + day : day;
          date = date.getFullYear() + '-' + month + '-' + day;
          form.append(item, date);
        } else if (null === this.transfer[item]) {
          continue;
        }  else {
          form.append(item, this.transfer[item]);
        }
      }

      this.$nextTick(() => {
        axios.post(url, form).then(response => {
          this.isLoading = false;
          if (this.$route.name === 'TransferEdit') {
            window.location.href = '/library/transfers/' + this.transfer.id;
          } else {
            window.location.href = '/library/transfers-to/';
          }
        }).catch(error => {
          this.isLoading = false;
          this.errors = error.response.data.errors;
          console.log('Errors:');
          console.log(error.response.data.errors);
        });
      });
    },
    getLibraries(){
      axios.get('/library/transfers/getLibrariesForTransfer').then(res => {
        if (!res.data.data) {
          return;
        }
        this.libraries.currentLibrary = res.data.data.currentLibrary;
        this.libraries.connectedLibraries = res.data.data.connectedLibraries;
      })
    },

    getTransfer(id) {
      axios.get('/library/transfers/' + id + '/getForEdit').then(response => {
        if (response.data.transfer) {
          this.transfer = response.data.transfer;
        }
      });
    },
  },
}
</script>

<style scoped>
    textarea.form-control {
      height: 16.3em;
      resize: none;
      /*color: #9E9E9E;*/
      font-size: 13px;
      line-height: 22px;
      border: none !important;
      margin-bottom: 10px
    }
    .form-control >>> .vs__open-indicator{
      transition: unset;
    }
  .form-control >>> .vs__dropdown-toggle,
  .form-control >>> .vs__dropdown-menu {
    font-size: 13px;
    border: none;
  }

  .form-control >>> .vs__actions {
    padding: 0;
    margin-right: -5px;
    align-items: unset;
  }
  .form-control >>> input.vs__search{
    padding: 0px;
  }

  .form-control >>> .vs__search,
  .form-control >>> .vs__selected {
    font-size: 13px;
    color: #414141;
    white-space: unset;
    padding: 5px;
    margin: 10px 5px 0 0 !important;
  }

  .form-group >>> .v-select{
    height: 40px;
    overflow: hidden;
  }
  .form-group >>> .v-select.vs--single:hover{
    overflow: unset;
  }
  .form-group >>> .v-select.vs--single .vs__selected-options .vs__selected{
    padding: 0;
    white-space: nowrap;
    width: 90%;
  }
  .form-group >>> .v-select.active,
    /*.form-group >>> .v-select:hover,*/
  .form-group >>> .v-select:focus-within {
    height: unset;
    overflow: unset;
  }

  .form-group >>>.vs__selected-options {
    width: 90%;
    overflow: hidden;
    padding: 0;
  }

  .form-control {
    min-height: 40px;
    color: #414141;
  }

  input {
    font-size: 13px;
  }

  .upload_file {
    margin-top: 20px;
  }

  .upload_file__lable {
    position: relative;
    display: block;
    max-width: 200px;
    width: 100%;
    padding: 10px 0;
    text-align: center;
    border-radius: 5px;
    background: orange;
    cursor: pointer;
  }

  .upload_file__lable input {
    display: none;
  }

  .upload_file__title {
    text-align: -moz-center;
    text-align: -webkit-center;
    text-align: center;
    color: #ffffff;
  }

  .upload_file__filename {
    position: absolute;
    left: 105%;
  }

  #comment {
    width: 100%;
  }

  .invalid-feedback {
    display: block;
  }

  .invalid-feedback span {
    display: block;
  }
</style>